"use client"
import React, { useState } from 'react';
import { BrowserView, MobileView, isBrowser, isMobile } from 'react-device-detect';


import {
  APIProvider,
  Map,
} from "@vis.gl/react-google-maps"
import NavBar from '../navigationBar';
import BuildingMarkers from '../components/buildingMarkers';
import Directions from '../components/directions';
import AddressInput from '../components/addressInput';
import MobileNavBar from '../mobileNavigationBar';


const mapOptions = {
    styles: [
        {
            featureType: 'poi',
            elementType: 'labels',
            stylers: [{ visibility: 'off' }],
        },
        {
            featureType: 'transit',
            elementType: 'labels',
            stylers: [{ visibility: 'off' }],
        },
        {
            featureType: 'water',
            elementType: 'labels',
            stylers: [{ visibility: 'off' }],
        },
        {
            featureType: "road",
            elementType: "geometry",
            stylers: [{ visibility: 'off' }],
          },
    ],
};


export default function Intro() {
  const [searchResult, setSearchResult] = useState("Result: none");

  const position = { lat: 36.99551, lng: -122.05909 }
  const [origin, setOrigin] = useState("630 Merrill Rd, Santa Cruz, CA 95064");
  const [desination, setDestination] = useState("411 Porter-Kresge Rd, Santa Cruz, CA 95064");

  const handleOriginAddressSubmit = (address) => {
    // Do something with the address, such as sending it to another function or API
    console.log('ORIGIN sub:', address);
    setOrigin(address);
    console.log('ORIGIN add:', origin);
  };
  const handleDestinationAddressSubmit = (address) => {
    console.log('DEST sub:', address);
    console.log('ORIGIN: ', origin);
    setDestination(address);
    console.log('DEST add:', desination);
  };


  function onLoad(autocomplete) {
    setSearchResult(autocomplete);
  }
  function onPlaceChanged() {
    if (searchResult != null) {
      const place = searchResult.getPlace();
      const name = place.name;
      const status = place.business_status;
      const formattedAddress = place.formatted_address;
      // console.log(place);
      console.log(`Name: ${name}`);
      console.log(`Business Status: ${status}`);
      console.log(`Formatted Address: ${formattedAddress}`);
    } else {
      alert("Please enter text");
    }
  }

  return (
    <>
      <BrowserView>
        <NavBar />
          <div style={{ height: "90vh", width: "100%" }}>
            <APIProvider apiKey={'AIzaSyAYbdsMlK7PQw_MB9o2cg-uDCpzpw8vGls'}>
              <Map
                  mapId={'36069e34920335e9'}
                  fullscreenControl={false}
                  mapTypeControl = {false}
              >
                <div className="searchBar" >
                  <h1>Start Location</h1>
                  <AddressInput onSubmitAddress={handleOriginAddressSubmit} />
                  <h1>End Location</h1>
                  <AddressInput onSubmitAddress={handleDestinationAddressSubmit} />
                </div>
                <BuildingMarkers />
                <Directions originAddress={origin} destinationAddress={desination} isMobile={false}/>
              </Map>
            </APIProvider>
          </div>
      </BrowserView>
      <MobileView>
        <div style={{ height: "90vh", width: "100%" }}>
            <APIProvider apiKey={'AIzaSyAYbdsMlK7PQw_MB9o2cg-uDCpzpw8vGls'}>
              <Map
                  mapId={'36069e34920335e9'}
                  fullscreenControl={false}
                  mapTypeControl = {false}
              >
                <div className="searchBar" >
                  <p>Start Location</p>
                  <AddressInput onSubmitAddress={handleOriginAddressSubmit} />
                  <p>End Location</p>
                  <AddressInput onSubmitAddress={handleDestinationAddressSubmit} />
                </div>
                <BuildingMarkers />
                <Directions originAddress={origin} destinationAddress={desination} isMobile={true}/>

              </Map>
            </APIProvider>
          </div>
          <MobileNavBar />
      </MobileView>
        
    </>
    
  )
}

